import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';

import * as UploadActions from './upload.actions';
import { STORAGE_API, UploadEntity } from '@dges/modules/storage/domain';

@Injectable()
export class UploadEffects {
  private actions$ = inject(Actions);
  private firebaseStorage = inject(STORAGE_API);

  upload$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UploadActions.upload),
      fetch({
        run: (action) => {
          const uploads: UploadEntity[] = [];
          action.files.forEach((file) => {
            uploads.push({
              id: new Date().getTime() + file.name,
              ...this.firebaseStorage.startUpload(file, action.folderName),
            });
          });
          return UploadActions.loadUploadSuccess({
            upload: uploads,
          });
        },
        onError: (action, error) => {
          console.error('Error', error);
          return UploadActions.loadUploadFailure({ error });
        },
      }),
    ),
  );
}
